class Expands {
  constructor (element) {
    this.$el = element
    this.$allExpand = this.$el.querySelectorAll('.expand')

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.init()
          observer.disconnect()
        }
      })
    })

    observer.observe(this.$el)
  }

  init () {
    if (this.$allExpand) {
      this.$allExpand.forEach(($expand) => {
        const expandBtn = $expand.querySelector('.expand-button')
        const expandContent = $expand.querySelector('.expand-content')
        const expandInitStart = $expand.dataset.expandInit

        if (expandInitStart && expandInitStart === 'open') {
          $expand.classList.add('open')
          expandContent.style.maxHeight = '100%'
        } else {
          expandContent.style.maxHeight = 0
          expandContent.style.overflow = 'hidden'
        }

        expandBtn.addEventListener('click', () => {
          // Fermer tous les autres expands avant d'ouvrir celui-ci
          this.$allExpand.forEach((otherExpand) => {
            if (otherExpand !== $expand) {
              otherExpand.classList.remove('open')
              const otherExpandContent = otherExpand.querySelector('.expand-content')
              otherExpandContent.style.maxHeight = 0
              otherExpandContent.style.overflow = 'hidden'
            }
          })

          $expand.classList.toggle('open')
          expandContent.style.maxHeight = $expand.classList.contains('open') ? '100%' : '0'

          expandContent.addEventListener(
            'transitionstart',
            () => {
              expandContent.style.overflow = 'hidden'
            },
            { once: true }
          )

          expandContent.addEventListener(
            'transitionend',
            () => {
              expandContent.style.overflow = $expand.classList.contains('open') ? 'visible' : 'hidden'
            },
            { once: true }
          )
        })
      })
    }
  }
}

export default function initExpands () {
  const $blocks = document.querySelectorAll('.expands')
  $blocks.forEach(($block) => {
    new Expands($block)
  })
}
